function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m23.061 20.25h-22.122c-.218 0-.426-.095-.568-.26-.142-.166-.205-.385-.173-.601l2.55-17.05c.208-1.356 1.353-2.339 2.723-2.339h13.059c1.37 0 2.515.983 2.722 2.337l2.551 17.052c.032.216-.031.435-.173.601-.144.165-.352.26-.569.26z",
  fill: "#00bcd4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m20.5 24h-17c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5h17c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5z",
  fill: "#0097a7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12 0h-6.529c-1.37 0-2.515.983-2.723 2.339l-2.537 16.963c.491-1.342 1.78-2.302 3.289-2.302h8.5v-3h-1.25c-.689 0-1.25-.561-1.25-1.25v-4.25h-2.25c-.3 0-.571-.179-.689-.454-.119-.275-.061-.595.145-.813l4.75-5c.142-.149.343-.223.544-.223z",
  fill: "#00a4b9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12 17h-8.5c-1.509 0-2.798.96-3.289 2.302-.136.374-.211.777-.211 1.198 0 1.93 1.57 3.5 3.5 3.5h8.5z",
  fill: "#008391"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 4.5,
  cy: 20.5,
  fill: "#ffc107",
  r: 1
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 9.5,
  cy: 20.5,
  fill: "#ffc107",
  r: 1
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m13.25 14h-2.5c-.689 0-1.25-.561-1.25-1.25v-4.25h-2.25c-.3 0-.571-.179-.689-.454-.119-.275-.061-.595.145-.813l4.75-5c.283-.298.805-.298 1.088 0l4.75 5c.206.217.264.537.146.812-.119.276-.39.455-.69.455h-2.25v4.25c0 .689-.561 1.25-1.25 1.25z",
  fill: "#fafafa"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12 2.01c-.201 0-.402.074-.544.223l-4.75 5c-.206.218-.264.538-.145.813.118.275.389.454.689.454h2.25v4.25c0 .689.561 1.25 1.25 1.25h1.25z",
  fill: "#dadada"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#dea806"
}, React.createElement("path", {
  d: "m5.5 20.5h-2c0 .552.448 1 1 1s1-.448 1-1z"
}), React.createElement("path", {
  d: "m10.5 20.5h-2c0 .552.448 1 1 1s1-.448 1-1z"
}));

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.16cfa328.svg";
export { ForwardRef as ReactComponent };